import { Dispatch } from 'redux';
import { ApiClient } from '../api.client';
import { ReduxStore } from '../payload-types';
import { GET_PROFILES_QUERY, LINKS } from '@trip-ux/constants';
import {
  USER_LISTING_RETRIEVE_SUCCESS,
  USER_LISTING_RETRIEVE_START,
  USER_LISTING_RETRIEVE_FAILED,
  USER_LISTING_FILTER,
  USER_LISTING_NAVPAGE,
  USER_LISTING_SORT
} from './types';
import { mapProfileToUserListing, mapProfileToAgentListing } from '../utils';

const AGENT = 'AGENT';

const dispatchUserListingRetrievalSuccess = dispatch => response => {
  const { data } = response;
  const mappedData = mapProfileToUserListing(data.profiles);
  dispatch({ type: USER_LISTING_RETRIEVE_SUCCESS, payload: mappedData });
};

const dispatchAgentListingRetrievalSuccess = dispatch => response => {
  const mappedData = mapProfileToAgentListing(response);
  dispatch({ type: USER_LISTING_RETRIEVE_SUCCESS, payload: mappedData });
};

export const retrieveAgentListing =
  (organizationCode: string) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
    dispatch({ type: USER_LISTING_RETRIEVE_START });
    return apiClient(dispatch, getState)
      .get(LINKS.AGENTLIST, { params: { organizationCode } })
      .then(dispatchAgentListingRetrievalSuccess(dispatch))
      .catch(e => {
        dispatch({ type: USER_LISTING_RETRIEVE_FAILED, payload: e });
      });
  };

export const retrieveUserListing =
  (organizationCode: string) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
    dispatch({ type: USER_LISTING_RETRIEVE_START });
    return apiClient(dispatch, getState)
      .post(LINKS.GRAPHQL, {
        query: GET_PROFILES_QUERY,
        variables: {
          where: {
            organizationCode
          }
        }
      })
      .then(dispatchUserListingRetrievalSuccess(dispatch))
      .catch(e => {
        dispatch({ type: USER_LISTING_RETRIEVE_FAILED, payload: e });
      });
  };

export const sortUserListing =
  (payload: unknown) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: USER_LISTING_SORT, payload });
  };

export const filterUserListing =
  (payload: string) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: USER_LISTING_FILTER, payload });
  };

export const navPageUserListing =
  (payload: number) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: USER_LISTING_NAVPAGE, payload });
  };
